export default "__VITE_ASSET__Bp6WS5tx__"